// client/src/utils/vendorApi.js
import api from './api';

export async function listVendorAccounts() {
  const { data } = await api.get('/vendor/accounts');
  return data || [];
}

export async function createVendorAccount(payload) {
  const { data } = await api.post('/vendor/accounts', payload);
  return data;
}

export async function deleteVendorAccount(id) {
  const { data } = await api.delete(`/vendor/accounts/${id}`);
  return data;
}

export async function listSources(accountId) {
  const { data } = await api.get(`/vendor/accounts/${accountId}/sources`);
  return data || [];
}

export async function createSource(accountId, payload = {}) {
  const { data } = await api.post(`/vendor/accounts/${accountId}/sources`, payload);
  return data;
}

export async function uploadImport(sourceId, file) {
  const form = new FormData();
  form.append('file', file);
  const { data } = await api.post(`/vendor/sources/${sourceId}/imports`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function searchVendorItems(params) {
  const { data } = await api.get('/vendor/items/search', { params });
  return data || [];
}

export async function quoteVendorPrice(params) {
  const { data } = await api.get('/vendor/prices/quote', { params });
  return data;
}

export async function listVendorItems(accountId) {
  const { data } = await api.get(`/vendor/accounts/${accountId}/items`);
  return data || [];
}

export async function createVendorItem(accountId, payload) {
  const { data } = await api.post(`/vendor/accounts/${accountId}/items`, payload);
  return data;
}

export async function updateVendorItem(itemId, payload) {
  const { data } = await api.put(`/vendor/items/${itemId}`, payload);
  return data;
}

export async function deleteVendorItem(itemId) {
  const { data } = await api.delete(`/vendor/items/${itemId}`);
  return data;
}

export default {
  listVendorAccounts,
  createVendorAccount,
  deleteVendorAccount,
  listSources,
  createSource,
  uploadImport,
  searchVendorItems,
  quoteVendorPrice,
  listVendorItems,
  createVendorItem,
  updateVendorItem,
  deleteVendorItem,
};
